import ProductList from "@/ui-sdk/components/product-list";
import { cloneNode, renderReact } from "../utils";

export const ReorderUI = {
  productList: async ({ isLoading }: { isLoading: boolean }) => {
    try {
      const productListElement = document.querySelector(
        '[data-helium-name="product-list"]',
      );

      if (!productListElement) {
        console.error("Product list element not found");
        return;
      }

      const applyLoadingState = () => {
        const productItems = productListElement.querySelectorAll(
          '[data-helium-name="product-item"]',
        );

        productItems.forEach((item) => {
          item.classList.remove("overflow-hidden");

          if (!item.querySelector(".backdrop-blur-animation")) {
            const blurOverlay = document.createElement("div");
            blurOverlay.className =
              "absolute inset-0 z-10 h-full w-full bg-white/10 backdrop-blur-animation";
            blurOverlay.style.cssText = `
              animation: blurPulse 2s ease-in-out infinite;
              backdrop-filter: blur(5px);
              @keyframes blurPulse {
                0%, 100% { backdrop-filter: blur(5px); }
                50% { backdrop-filter: blur(20px); }
              }
            `;
            if (item.firstChild) {
              item.insertBefore(blurOverlay, item.firstChild);
            } else {
              item.appendChild(blurOverlay);
            }
          }
        });
      };

      const removeLoadingState = () => {
        const productItems = productListElement.querySelectorAll(
          '[data-helium-name="product-item"]',
        );

        productItems.forEach((item) => {
          item.classList.add("overflow-hidden");
          const blurOverlay = item.querySelector(".backdrop-blur-animation");
          if (blurOverlay) {
            blurOverlay.remove();
          }
        });
      };

      if (isLoading) {
        applyLoadingState();
        return;
      }

      removeLoadingState();

      const existingFilteredProductList = document.querySelector(
        '[data-helium-name="filtered-product-list"]',
      );

      if (existingFilteredProductList) {
        existingFilteredProductList.remove();
      }

      productListElement.style.display = "none";

      const newElement = document.createElement("div");
      newElement.setAttribute("data-helium-name", "filtered-product-list");
      newElement.className = productListElement.className;

      productListElement.parentNode.insertBefore(
        newElement,
        productListElement.nextSibling,
      );

      let existingNode = window.helium.datastore?.memory?.html?.product;
      let existingProduct = null;

      if (!existingNode) {
        console.error("No valid 'data-helium-name' attribute found.");
        const getNode = document.querySelector(
          '[data-helium-name="product-item"]',
        );
        if (getNode) {
          existingNode = getNode;
        } else return;
      }

      const existingNodeHandle = existingNode.getAttribute(
        "data-helium-product-handle",
      );

      if (existingNodeHandle) {
        existingProduct = (
          await window.helium.datastore.getProduct({
            id: existingNodeHandle,
          })
        ).details;
      }

      renderReact(
        ProductList,
        {
          products: window.helium.datastore.memory.filters.products || [],
          existingNode,
          existingProduct,
        },
        newElement,
      );

      console.log("Product list has been updated");
    } catch (e) {
      console.log("Error updating product list", e);
    }
  },
};
